import { getMessages } from '../../../../../../../store/constants';

export const CARD_COLOR_TAGS_BUTTON = getMessages().getText('common.color_tags');
